import React, { Component } from "react";
import { Icon, Grid } from "semantic-ui-react";

class Item extends Component {
  render() {
    // if the element is an array, display the two lines accordingly
    // Useful only for affectations
    return typeof this.props.info === "string" ? (
      <div>
        <Grid column={2} padded>
          <Grid.Row>
            <Grid.Column width={2}>
              <Icon name={this.props.icon} />
            </Grid.Column>
            {(() => {
              switch(this.props.icon) {
                case 'mail':
                  return (
                    <Grid.Column textAlign="right" width={14}>
                      <a href={"mailto:" + this.props.info}>
                        {this.props.info}
                      </a>
                    </Grid.Column>);
                case 'phone':
                  return (
                    <Grid.Column textAlign="right" width={14}>
                      <a href={"tel:" + this.props.info}>
                      {this.props.info}
                      </a>
                    </Grid.Column>);
                case 'file text':
                  return (
                    <Grid.Column textAlign="left" width={14}>
                      <a>{this.props.info}</a>
                    </Grid.Column>);
                default:
                  return (
                    <Grid.Column textAlign="right" width={14}>
                      <a>{this.props.info}</a>
                    </Grid.Column>);
              }
            })()}
          </Grid.Row>
        </Grid>
      </div>
    ) : (
      <div>
        <Grid column={2} padded>
          <Grid.Row>
            <Grid.Column width={2}>
              <Icon name={this.props.icon} />
            </Grid.Column>
            <Grid.Column textAlign="right" width={14}>
              {this.props.info[0]}<br />
              {this.props.info[1]}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/scenes/ProfilPage/components/item.js